// proto/v2/research/progress_view.proto
//
// Research Progress View v2 — the server-maintained projection that hydrates
// the redesigned live progress UI (diagram + live insights) in one round-trip
// on mount/reconnect, plus the incremental delta events that ride on top.
//
// Design: docs/plans/2026-06-13-research-progress-view-design.md
// Plan:   docs/plans/2026-06-13-research-progress-view-plan.md
//
// All messages here are OUTBOUND (server -> client). The snapshot is sent on
// research (re)subscribe and via GET /api/v1/research/:id/progress-view; the
// *Event messages are deltas. Snapshot and deltas share field shapes and carry
// a monotonic `seq` so the client can discard any delta with seq <= snapshot.seq.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file research/progress_view.proto (package lvdr.v2.research, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CreditInfo, ProgressInfo } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { DAGEdge, DAGNode, TemplateGroup } from "../dag/dag_pb";
import { file_dag_dag } from "../dag/dag_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file research/progress_view.proto.
 */
export const file_research_progress_view: GenFile = /*@__PURE__*/
  fileDesc("ChxyZXNlYXJjaC9wcm9ncmVzc192aWV3LnByb3RvEhBsdmRyLnYyLnJlc2VhcmNoIp0BCg9SZXNlYXJjaEZpbmRpbmcSDwoHbm9kZV9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEgwKBGtpbmQYAyABKAkSEAoIb25lX2xpbmUYBCABKAkSFQoNc291cmNlX2RvbWFpbhgFIAEoCRILCgN1cmwYBiABKAkSEgoKY29uZmlkZW5jZRgHIAEoARITCgtyZWxpYWJpbGl0eRgIIAEoASJuChVSZXNlYXJjaEluc2lnaHREaWdlc3QSDwoHdmVyc2lvbhgBIAEoDRISCgpzdGF0ZW1lbnRzGAIgAygJEjAKDGdlbmVyYXRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiOgoYUmVzZWFyY2hTZWN0aW9uc1Byb2dyZXNzEg8KB3dyaXR0ZW4YASABKAUSDQoFdG90YWwYAiABKAUi0AQKFFJlc2VhcmNoUHJvZ3Jlc3NWaWV3EhMKC3Jlc2VhcmNoX2lkGAEgASgJEgsKA3NlcRgCIAEoBBIuCgp1cGRhdGVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBINCgVwaGFzZRgEIAEoCRIVCg1jdXJyZW50X3JvdW5kGAUgASgFEi0KB21ldHJpY3MYBiABKAsyHC5sdmRyLnYyLmNvbW1vbi5Qcm9ncmVzc0luZm8SEwoLZ3JhcGhfc3RhdGUYByABKAkSGgoSZ3JhcGhfc3RhdGVfcmVhc29uGAggASgJEiMKBW5vZGVzGAkgAygLMhQubHZkci52Mi5kYWcuREFHTm9kZRIjCgVlZGdlcxgKIAMoCzIULmx2ZHIudjIuZGFnLkRBR0VkZ2USLQoJdGVtcGxhdGVzGAsgAygLMhoubHZkci52Mi5kYWcuVGVtcGxhdGVHcm91cBI6Cg9yZWNlbnRfZmluZGluZ3MYDCADKAsyIS5sdmRyLnYyLnJlc2VhcmNoLlJlc2VhcmNoRmluZGluZxJACg9oZWFkbGluZV9kaWdlc3QYDSABKAsyJy5sdmRyLnYyLnJlc2VhcmNoLlJlc2VhcmNoSW5zaWdodERpZ2VzdBI8CghzZWN0aW9ucxgOIAEoCzIqLmx2ZHIudjIucmVzZWFyY2guUmVzZWFyY2hTZWN0aW9uc1Byb2dyZXNzEisKB2NyZWRpdHMYDyABKAsyGi5sdmRyLnYyLmNvbW1vbi5DcmVkaXRJbmZvIm4KFVJlc2VhcmNoRmluZGluZ3NFdmVudBITCgtyZXNlYXJjaF9pZBgBIAEoCRILCgNzZXEYAiABKAQSMwoIZmluZGluZ3MYAyADKAsyIS5sdmRyLnYyLnJlc2VhcmNoLlJlc2VhcmNoRmluZGluZyJ3ChpSZXNlYXJjaEluc2lnaHREaWdlc3RFdmVudBITCgtyZXNlYXJjaF9pZBgBIAEoCRILCgNzZXEYAiABKAQSNwoGZGlnZXN0GAMgASgLMicubHZkci52Mi5yZXNlYXJjaC5SZXNlYXJjaEluc2lnaHREaWdlc3RCKVonZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL3Jlc2VhcmNoYgZwcm90bzM", [file_google_protobuf_timestamp, file_common_common, file_dag_dag]);

/**
 * A single discovered fact surfaced live during the run. Derived from a
 * cascade-extracted KnowledgeNode, filtered server-side for signal.
 *
 * @generated from message lvdr.v2.research.ResearchFinding
 */
export type ResearchFinding = Message<"lvdr.v2.research.ResearchFinding"> & {
  /**
   * DAG node id that produced this finding (KnowledgeNode.Source.SourceID, a
   * DAG TaskID string — NOT the knowledge-graph node hash). Powers the ambient
   * pulse: when this finding lands, the diagram node with this id pulses.
   *
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * length-capped at emission
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "entity" | "concept"
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * truncated description/summary, length-capped
   *
   * @generated from field: string one_line = 4;
   */
  oneLine: string;

  /**
   * e.g. "wikipedia.org"
   *
   * @generated from field: string source_domain = 5;
   */
  sourceDomain: string;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * 0.0-1.0
   *
   * @generated from field: double confidence = 7;
   */
  confidence: number;

  /**
   * TrustProfile composite, 0.0-1.0
   *
   * @generated from field: double reliability = 8;
   */
  reliability: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchFinding.
 * Use `create(ResearchFindingSchema)` to create a new message.
 */
export const ResearchFindingSchema: GenMessage<ResearchFinding> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 0);

/**
 * The latest synthesized headline insights ("what to expect from the report").
 * Produced by the throttled BAML synthesis step; replace-in-place by version.
 *
 * @generated from message lvdr.v2.research.ResearchInsightDigest
 */
export type ResearchInsightDigest = Message<"lvdr.v2.research.ResearchInsightDigest"> & {
  /**
   * @generated from field: uint32 version = 1;
   */
  version: number;

  /**
   * 3-5, each length-capped
   *
   * @generated from field: repeated string statements = 2;
   */
  statements: string[];

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 3;
   */
  generatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchInsightDigest.
 * Use `create(ResearchInsightDigestSchema)` to create a new message.
 */
export const ResearchInsightDigestSchema: GenMessage<ResearchInsightDigest> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 1);

/**
 * @generated from message lvdr.v2.research.ResearchSectionsProgress
 */
export type ResearchSectionsProgress = Message<"lvdr.v2.research.ResearchSectionsProgress"> & {
  /**
   * @generated from field: int32 written = 1;
   */
  written: number;

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchSectionsProgress.
 * Use `create(ResearchSectionsProgressSchema)` to create a new message.
 */
export const ResearchSectionsProgressSchema: GenMessage<ResearchSectionsProgress> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 2);

/**
 * The full projection. One per research, maintained incrementally server-side.
 *
 * @generated from message lvdr.v2.research.ResearchProgressView
 */
export type ResearchProgressView = Message<"lvdr.v2.research.ResearchProgressView"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * monotonic delta cursor
   *
   * @generated from field: uint64 seq = 2;
   */
  seq: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string phase = 4;
   */
  phase: string;

  /**
   * @generated from field: int32 current_round = 5;
   */
  currentRound: number;

  /**
   * @generated from field: lvdr.v2.common.ProgressInfo metrics = 6;
   */
  metrics?: ProgressInfo | undefined;

  /**
   * Graph (the projection owns this — the FE diagram does not depend on dagStore)
   *
   * @generated from field: string graph_state = 7;
   */
  graphState: string;

  /**
   * @generated from field: string graph_state_reason = 8;
   */
  graphStateReason: string;

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGNode nodes = 9;
   */
  nodes: DAGNode[];

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGEdge edges = 10;
   */
  edges: DAGEdge[];

  /**
   * @generated from field: repeated lvdr.v2.dag.TemplateGroup templates = 11;
   */
  templates: TemplateGroup[];

  /**
   * Insights
   *
   * ring buffer, newest-first
   *
   * @generated from field: repeated lvdr.v2.research.ResearchFinding recent_findings = 12;
   */
  recentFindings: ResearchFinding[];

  /**
   * @generated from field: lvdr.v2.research.ResearchInsightDigest headline_digest = 13;
   */
  headlineDigest?: ResearchInsightDigest | undefined;

  /**
   * @generated from field: lvdr.v2.research.ResearchSectionsProgress sections = 14;
   */
  sections?: ResearchSectionsProgress | undefined;

  /**
   * Credits. Mirrored from the same engine metrics as
   * ExecutionProgressEvent.credits — the progress page reads this projection,
   * not the execution event stream, so the number has to ride both channels.
   *
   * @generated from field: lvdr.v2.common.CreditInfo credits = 15;
   */
  credits?: CreditInfo | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchProgressView.
 * Use `create(ResearchProgressViewSchema)` to create a new message.
 */
export const ResearchProgressViewSchema: GenMessage<ResearchProgressView> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 3);

/**
 * Delta: a batch of newly-absorbed findings (newest-first).
 *
 * @generated from message lvdr.v2.research.ResearchFindingsEvent
 */
export type ResearchFindingsEvent = Message<"lvdr.v2.research.ResearchFindingsEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: uint64 seq = 2;
   */
  seq: bigint;

  /**
   * @generated from field: repeated lvdr.v2.research.ResearchFinding findings = 3;
   */
  findings: ResearchFinding[];
};

/**
 * Describes the message lvdr.v2.research.ResearchFindingsEvent.
 * Use `create(ResearchFindingsEventSchema)` to create a new message.
 */
export const ResearchFindingsEventSchema: GenMessage<ResearchFindingsEvent> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 4);

/**
 * Delta: the headline digest refreshed.
 *
 * @generated from message lvdr.v2.research.ResearchInsightDigestEvent
 */
export type ResearchInsightDigestEvent = Message<"lvdr.v2.research.ResearchInsightDigestEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: uint64 seq = 2;
   */
  seq: bigint;

  /**
   * @generated from field: lvdr.v2.research.ResearchInsightDigest digest = 3;
   */
  digest?: ResearchInsightDigest | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchInsightDigestEvent.
 * Use `create(ResearchInsightDigestEventSchema)` to create a new message.
 */
export const ResearchInsightDigestEventSchema: GenMessage<ResearchInsightDigestEvent> = /*@__PURE__*/
  messageDesc(file_research_progress_view, 5);

